import UnenrolledStudentHome from "../views/Accepted/UnenrolledStudentHome";
import ChiefCareer from "../views/Admin/ChiefCareer";
import Details from "../views/Admin/Details";
import Reports from "../views/Admin/Reports";
import { CreateStudent, UpdateStudent } from "../views/Admin/Student";
import { CreatePeriod, UpdatePeriod, ListPeriods } from "../views/Admin/Period";

const routes = [
    {
        path: 'aspirantes/inicio',
        component: UnenrolledStudentHome,
        field: 'inscrito',
        redirect: '/aspirantes/login'
    },
    {
        path: 'admin/inicio',
        component: ChiefCareer,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/documentos/:controlNumber',
        component: Details,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/reportes',
        component: Reports,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/nuevo',
        component: CreateStudent,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/aspirante/:controlNumber',
        component: UpdateStudent,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/periodos',
        component: ListPeriods,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/periodos/nuevo',
        component: CreatePeriod,
        field: 'role',
        redirect: '/admin/login'
    },
    {
        path: 'admin/periodos/:slug',
        component: UpdatePeriod,
        field: 'role',
        redirect: '/admin/login'
    },
]

export default routes;